import { Cell } from '../grid/Cell'
import { BaseModal } from './BaseModal'

type Props = {
  isOpen: boolean
  handleClose: () => void
}

export const InfoModal = ({ isOpen, handleClose }: Props) => {
  return (
    <BaseModal
      title="Хэрхэн тоглох вэ?"
      isOpen={isOpen}
      handleClose={handleClose}
    >
      <p className="text-sm text-gray-500 dark:text-gray-300">
        6 оролдлогоор үгийг таа. Оролдлого бүрийн дараа, үсгийн нүднүүдийн өнгө
        солигдох ба энэ нь таны оролдого хэр ойртсоныг илэрхийлнэ.
      </p>

      <div className="flex justify-center mt-4 mb-1">
        <Cell
          isRevealing={true}
          isCompleted={true}
          value="Г"
          status="correct"
        />
        <Cell value="Э" />
        <Cell value="Р" />
        <Cell value="Э" />
        <Cell value="Л" />
      </div>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        "Г" үсэг тухайн үгэнд агуулагдсан ба зөв байрлалд байна.
      </p>

      <div className="flex justify-center mt-4 mb-1">
        <Cell value="Г" />
        <Cell value="Э" />
        <Cell
          isRevealing={true}
          isCompleted={true}
          value="Р"
          status="present"
        />
        <Cell value="Э" />
        <Cell value="Л" />
      </div>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        "Р" үсэг тухайн үгэнд агуулагдсан ба буруу байрлалд байна.
      </p>

      <div className="flex justify-center mt-4 mb-1">
        <Cell value="Г" />
        <Cell isRevealing={true} isCompleted={true} value="Э" status="absent" />
        <Cell value="Р" />
        <Cell isRevealing={true} isCompleted={true} value="Э" status="absent" />
        <Cell value="Л" />
      </div>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        "Э" үсэг тухайн үгэнд агуулагдаагү байна.
      </p>

      <p className="mt-6 text-sm italic text-gray-500 dark:text-gray-300">
        This is an open source version of the word guessing game we all know and
        love -{' '}
        <a
          href="https://github.com/cwackerfuss/react-wordle"
          className="font-bold underline"
        >
          check out the code here
        </a>{' '}
      </p>
    </BaseModal>
  )
}
